<template>
    <div>
        <v-container fluid>
            <v-skeleton-loader
            :loading="!$parent.$parent.$parent.flagNav"
            transition="scale-transition"
            max-height="64" 
            type="table-heading"
            >
                <v-toolbar dark class="header-title">
                    <v-toolbar-title class="title">{{ $t('FileManagement_title') }}</v-toolbar-title>
                    <v-spacer />
                    <v-toolbar-title class="title">{{ today }}</v-toolbar-title>
                </v-toolbar>
            </v-skeleton-loader>
            <v-card class="card2" style="margin-top: 1rem">
                <v-flex class="flex">
                    <v-row style="margin-top: 1rem">
                        <v-col cols="12" sm="3" md="2" class="mt-3">
                            <v-menu v-model="startDateFlag" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" location="bottom" min-width="auto">
                                <template  v-slot:activator="{ on, attrs }">
                                    <v-text-field id="startdate-field-filemanagement" v-model="startDate" :label="$t('startDate')" prepend-icon="mdi-calendar" readonly outlined clearable v-bind="attrs" v-on="on" dense></v-text-field>
                                </template>
                                <v-date-picker v-model="startDate" :max="endDate != null ? endDate : null" @input="startDateFlag = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="3" md="2" class="mt-3">
                            <v-menu v-model="endDateFlag" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" location="bottom" min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field id="enddate-field-filemanagement"  v-model="endDate" :label="$t('endDate')" prepend-icon="mdi-calendar" readonly outlined clearable v-bind="attrs" v-on="on" dense></v-text-field>
                                </template>
                                <v-date-picker v-model="endDate" :min="startDate != null ? startDate : null" @input="endDateFlag = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="mt-3">
                            <v-text-field 
                                id="id-field-search-filemanagement"
                                :label="$t('fileName')"
                                v-model="searchFileName"
                                @keydown.enter="Search"
                                style="margin-top: -3px;"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-btn fab small class="primary white--text mt-3" @click="Search">
                                <v-icon size="30">mdi-magnify</v-icon> 
                            </v-btn>
                        </v-col>
                        <v-col justify="end" align="end">
                            <v-btn class="red white--text mt-3" :disabled="dataTable.length === 0"  @click="DeleteAll()">
                                <v-icon size="20" style="padding-right: 5px"> mdi-delete-outline</v-icon>{{ $t('deleteAll') }}
                            </v-btn>
                            <v-tooltip top max-width="40vw">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon text x-small style="position: absolute; top: 60px; right: 15px" v-bind="attrs" v-on="on"> mdi-information-outline</v-icon>
                                </template>
                                <span>{{ $t('_InfoForDeleteAllFile') }}</span>
                            </v-tooltip>
                        </v-col> 
                    </v-row>
                    <v-data-table
                        :items-per-page="itemsPerPage"
                        :server-items-length="searchTotalTable"
                        :options.sync="options"
                        :items="dataTable"
                        :headers="headers"
                    >
                        <template v-slot:item="{item}">
                            <tr>
                                <td style="text-align: center">{{ item.number }}</td>
                                <td>{{ item.fileName }}</td>
                                <td>{{ item.createDate }}</td>
                                <td>{{ item.createBy }}</td>
                                <td style="text-align: center">
                                    <v-btn id="button-view-filemanagement" icon @click="View(item.fileManagerID)">
                                        <v-tooltip top open-delay="500">
                                            <template v-slot:activator="{ on, attrs }">
                                               <v-icon  
                                                    style="color:#848382"
                                                    v-bind="attrs" v-on="on"
                                                    >mdi-file-eye
                                               </v-icon>
                                            </template>
                                            <span>{{ $t('view') }}</span>
                                        </v-tooltip>           
                                    </v-btn>
                                    <v-btn id="button-delete-filemanagement" icon @click="DeleteFile(item.fileManagerID)">
                                        <v-tooltip top open-delay="500">
                                            <template v-slot:activator="{ on, attrs }">
                                                <img alt="img-delete" :src="images.delete" v-bind="attrs" v-on="on" />
                                            </template>
                                            <span>{{ $t('delete') }}</span>
                                        </v-tooltip>         
                                    </v-btn>
                                </td>
                            </tr>
                        </template>    
                    </v-data-table>
                </v-flex>
            </v-card>
        </v-container>
        <!--Dialog deleteAll-->
        <v-dialog v-model="dialogDeleteAll" persistent max-width="450" max-height="600">
            <v-card>
                <v-card-title class="text-h6 grey lighten-2" style="position: sticky; top: 0px">
                    {{ $t('confirmDeleteConfirmation') }}
                </v-card-title>
                <v-card-text style="margin-top: 1rem">
                    <p style="color:black; font-size: 14px;">
                        {{ $t('_DeleteAllItemsCountPrefix') }} <span :style="{ color: totalTable > 0 ? 'red' : 'green' }">
                            {{ totalTable }}</span> {{ $t('_DeleteAllItemsCountSuffix') }}</p>
                    <p style="color:black; font-size: 12px;">{{ $t('_PleaseFillDeleteToConfirm') }}</p>
                    <v-row>
                        <v-col cols="8" sm="8" md="8">               
                            <v-text-field
                                v-model="deleteInput"
                                :rules="[rules.required]"
                                outlined
                                dense
                                clearable 
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>                
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="text-h6 grey lighten-2">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogDeleteAll = false">{{ $t('cancel') }}</v-btn>
                    <v-btn :disabled="deleteInput.toLowerCase() !== 'delete'" color="red darken-1" text @click="DeleteAllFile()">
                        {{ $t('delete') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--Dialog viewFileManager-->
        <v-dialog v-model="dialogViewFileManager" persistent max-width="1000">
            <v-card>
                <v-card-title class="text-h5 grey lighten-2" >
                    {{ $t('view_detail') }}
                </v-card-title>
                <v-card-text style="margin-top: 1rem">
                    <v-row>
                        <v-col cols="12" sm="12" md="5">
                            <v-text-field 
                                :label="$t('fileName')"
                                v-model="viewData.fileName"
                                outlined dense readonly>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                            <v-text-field 
                                :label="$t('fileType')"
                                v-model="viewData.fileType"
                                outlined dense readonly>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="2">
                            <v-text-field 
                                :label="$t('sizeKB')"
                                v-model="viewData.size"
                                outlined dense readonly>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="5">
                            <v-text-field 
                                :label="$t('fileUrl')"
                                v-model="viewData.fileUrl"
                                outlined dense readonly>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="2">
                            <v-text-field 
                                :label="$t('container')"
                                v-model="viewData.container"
                                outlined dense readonly>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <!--Image-->
                    <v-row justify="center" align="center" class="mt-8">
                        <v-col cols="12" md="6" class="d-flex justify-center">
                            <v-img
                                v-if="viewData.container === 'imageupload'"
                                :src="viewData.fileUrl"
                                alt="File Image"
                                max-width="100%"
                                max-height="400px"
                                contain
                            ></v-img>
                            <v-img
                                v-else
                                src="https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
                                alt="No Image Available"
                                max-width="100%"
                                max-height="400px"
                                contain
                            ></v-img>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn id="button-close-popupview-filemanagement" color="blue darken-1" text @click="closeView()">{{ $t('close') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Loading Please Wait... -->
        <v-overlay  :value="dialog">
            <v-dialog v-model="dialog" persistent width="300">
                <v-card color="#1976D2" dark>
                    <v-card-text class="white--text">
                        {{ $t('loadingPleaseWait') }}
                        <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-overlay>
    </div>
</template>
<script>
import dateUtils from '../plugins/date-utils';
import moment from 'moment';
import LogTrace from '@/api/function.js';
export default {
    name: 'FileManagements',
    mixins: [LogTrace],
    data() {
        return {
            today: null,
            searchModelName: null,
            options: {},
            images: {
                delete: require('@/assets/delete1.png'),
            },
            loading: true,
            dialog: false,
            isSearch: false,
            searchTotalTable: 0,
            totalTable: 0,
            itemsPerPage: 10,
            sortBy: [],
            sortDesc: [],
            dataTable: [],
            startDateFlag: false,
            endDateFlag: false,
            startDate: null,
            endDate: null,
            dialogDeleteAll: false,
            deleteInput: "",
            searchFileName: "",
            rules: {
                required: (value) => !!value || this.$t('requiredField'),
            },
            dialogViewFileManager: false,
            viewData: {
                // fileManagerID: null,
                // groupFileManagerID: null,
                fileName: null,
                fileType: null,
                size: null,
                fileUrl: null,
                container: null,
            }
        };
    },
    computed: {
        headers() {
            return [
                {text: 'No', align: 'center', value: 'number', sortable: false, width: '10%'},
                {text: 'File Name', align: 'center', value: 'fileName', sortable: true, width: '35%'},
                {text: 'Create date', align: 'center', value: 'createDate', sortable: true, width: '15%'},
                {text: 'Create by', align: 'center', value: 'createBy', sortable: true, width: '15%'},
                {text: 'Action', align: 'center', sortable: false, width: '25%'}
            ];
        },
    },
    watch: {
        options: {
            handler() {
                this.Get();
            },
            deep: true,
        },
    },
    methods: {
        Search() {
            this.isSearch = true;
            this.options.page = 1;
            this.dialog = true;
            this.Get();
        },
        Get() {
            try {
                this.dialog = true;
                const {page, itemsPerPage} = this.options;
                this.sortBy = this.options.sortBy.length == 0 ? null : this.options.sortBy[0];
                this.sortDesc = this.options.sortDesc.length == 0 ? null : this.options.sortDesc[0];
                if (this.startDate != null && this.endDate != null) {
                    let temp = {
                    page: this.isSearch ? 1 : page,
                    perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
                    fileName: this.searchFileName,
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    };
                    this.$call.GetTableFileManager(
                        temp,
                        (dataResponse) => {
                            if (dataResponse.status == 0) {
                                this.searchTotalTable = dataResponse.data.total;
                                this.dataTable = dataResponse.data.data;
                                this.totalTable = dataResponse.data.total;
                            } else {
                                this.dataTable = [];
                                this.searchTotalTable = 0;
                                this.totalTable = 0;
                            }
                            this.isSearch = false;
                            this.dialog = false;
                        },
                        (errorResource) => {
                            this.isSearch = false;
                            this.dialog = false;
                            console.error(errorResource);
                        }
                    );
                }
                else{
                    this.$swal.fire({
                        icon: 'warning',
                        title: this.$t('warning'),
                        text: this.$t('warnningStartdateEnddate'),
                        showConfirmButton: false,
                        timer: 3000,
                    });
                    return;
                }     
               
            } catch (error) {
                this.LogTrace(error, 'Get');
            } 
        },
        DeleteFile(id) {
            try {
                this.$swal.fire({
                    title: this.$t('confirmDeletion'),
                    text: this.$t('confirmDeletionFile'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.$t('confirm'),
                    cancelButtonText: this.$t('cancel'),
                    reverseButtons: false,
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.dialog = true;
                        this.$call.DeleteFileManager(
                            id,
                            (dataResponse) => {
                                if (dataResponse.status == 0) {
                                    this.$swal.fire({
                                        icon: 'success',
                                        title: dataResponse.message,
                                        showConfirmButton: false,
                                        timer: 1500,
                                    });
                                    this.Get();
                                }
                            },
                            (errorResource) => {
                                this.dialog = false;
                                console.error(errorResource);
                            }
                        );
                    }
                });
            } catch (error) {
              this.LogTrace(error, 'DeleteFile');
            }
        },
        DeleteAll() {
            this.dialogDeleteAll = true;
            this.deleteInput = "";
        },
        DeleteAllFile() {
            try {
                this.$swal.fire({
                    title: this.$t('confirmDeletion'),
                    text: this.$t('confirmDeletionAllFile'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.$t('confirm'),
                    cancelButtonText: this.$t('cancel'),
                    reverseButtons: false,
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.dialog = true;
                        let fileIds = this.dataTable.filter((item) => item.fileManagerID !== undefined).map((item) => item.fileManagerID);
                        this.$call.DeleteAllFileManager( 
                            fileIds, 
                            (dataResponse) => {
                                if (dataResponse.status == 0) {
                                    this.$swal.fire({
                                        icon: 'success',
                                        title: dataResponse.message,
                                        showConfirmButton: false,
                                        timer: 1500,
                                    });
                                }
                                this.dialogDeleteAll = false;
                                this.Get();
                            },
                            (errorResource) => {
                                this.dialog = false;
                                console.error(errorResource);
                            }
                        );
                    }
                });

            } catch (error) {
              this.LogTrace(error, 'DeleteAllFile');
            }
        },
        View(id) {
            try {
                this.dialogViewFileManager = true;
                this.$call.GetViewFileManagerById(
                    id,
                    (dataResponse) => {
                        if (dataResponse.status == 0) {
                            this.viewData.fileName = dataResponse.data.data[0].fileName;
                            this.viewData.fileType = dataResponse.data.data[0].fileType;
                            this.viewData.size = dataResponse.data.data[0].size;
                            this.viewData.fileUrl = dataResponse.data.data[0].fileURL;
                            this.viewData.container = dataResponse.data.data[0].container;
                        }
                        
                    },
                    (errorResource) => {
                        console.error(errorResource);
                    }       
                );
            } catch (error) {
              this.LogTrace(error, 'View');
            }             
        },
        closeView() {
                        this.dialogViewFileManager = false;
                        this.viewData.fileName = null;
                        this.viewData.fileType = null;
                        this.viewData.size = null;
                        this.viewData.fileUrl = null;
                        this.viewData.container = null;
        },
 
        convertDateToString2(date, seperator = '-') {
            return dateUtils.getStringFromDatePickFormatDatePick2(moment(date).toDate(), seperator);
        },
    },
    mounted() {
        this.GetDate();
        const date = new Date();
        this.startDate = this.convertDateToString2(date);
        this.endDate = this.convertDateToString2(date);
    },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
</style>